// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorPage_errorContainer__acVkI","errorDetails":"ErrorPage_errorDetails__3PxA1","errorPageRetryBtn":"ErrorPage_errorPageRetryBtn__2Tm3L"};